import React from 'react';

const AutoSizeTitle = ({
  text = '',
  className = 'internal-page-main-title',
  baseSize = 22,
}) => {
  const computeTitleFontSize = (t) => {
    if (!t) return baseSize;
    const len = t.length;
    if (len <= 24) return baseSize;
    if (len <= 36) return Math.max(baseSize - 2, 14);
    if (len <= 50) return Math.max(baseSize - 4, 14);
    if (len <= 70) return Math.max(baseSize - 6, 12);
    return Math.max(baseSize - 8, 12);
  };

  const fontSize = computeTitleFontSize(text);

  return (
    <div className={className} style={{ fontSize, lineHeight: 1.15 }}>
      {text}
    </div>
  );
};

export default AutoSizeTitle;
